import React from "react";
import { ucFirst } from "../../../helpers/string_helper";
import { ActivityModule, Modules } from "../../../constants/Module";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ProjectStatuses } from "../../../constants/Status";
import { withTranslation } from "react-i18next";
function ApprovalUserUpdate({item, t}) {
  return (
    <div className="mx-2">
      { item?.payload?.status && typeof item?.payload?.status === "object" && item?.payload?.status?.new === ProjectStatuses.IN_APPROVAL && (
      <div>
        <strong>{ucFirst(Modules.APPROVAL_USER)} </strong>
        {t('was updated for')}{" "}
        <strong>
          {item.payload.module} ({item?.payload?.moduleDetails?.name} {item.payload.module === ActivityModule.PROJECT ? `| ${item?.payload?.moduleDetails?.uniqueProjectId}`:''})
        </strong>
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
        )}
      <div>
        {item?.payload?.status && typeof item?.payload?.status === "object" && (
          <div className="mx-2">
            <div className="d-flex align-items-center change_status">
              {item?.payload?.status?.new === ProjectStatuses.REJECTED && (
                <div className="d-flex align-items-center change_status">
                  <div>
                  <span>
                    <strong>{ucFirst(item.payload.module)} ({item?.payload?.moduleDetails?.name}  {item.payload.module === ActivityModule.PROJECT ? `| ${item?.payload?.moduleDetails?.uniqueProjectId}`:''})</strong> {t('is rejected by')}{" "}
                    <strong>
                      {item?.creator?.projectUsers[0]?.role?.name} [
                      {item?.creator?.name} | {item?.creator?.uniqueUserId}]
                    </strong>
                  </span>
                  <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                  </div>
                </div>
              )}
              {item?.payload?.status?.new === 'Approved' && (
                <div className="d-flex align-items-center change_status">
                  <div>
                  <span>
                    <strong>{ucFirst(item.payload.module)} ({item?.payload?.moduleDetails?.name}  {item.payload.module === ActivityModule.PROJECT ? `| ${item?.payload?.moduleDetails?.uniqueProjectId}`:''})</strong> {t('is approved by')}{" "}
                    <strong>
                      {item?.creator?.projectUsers[0]?.role?.name} [
                      {item?.creator?.name} | {item?.creator?.uniqueUserId}]
                    </strong>
                  </span>
                  <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                  </div>
                </div>
              )}
              {item?.payload?.status?.new ===
                ProjectStatuses.IN_APPROVAL && (
                <div className="d-flex align-items-center change_status">
                  <span>
                    <strong>{ucFirst(item.payload.module)} ({item?.payload?.moduleDetails?.name}  {item.payload.module === ActivityModule.PROJECT ? `| ${item?.payload?.moduleDetails?.uniqueProjectId}`:''})</strong> {t('is sent for approval by')}{" "}
                    <strong>
                      {item?.creator?.projectUsers[0]?.role?.name} [
                      {item?.creator?.name} | {item?.creator?.uniqueUserId}]
                    </strong>
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default withTranslation()(ApprovalUserUpdate);